import React, { forwardRef, useEffect, useState } from "react";
import {
  Dialog,
  Slide,
  Box,
  Typography,
} from "@mui/material";
import axiosInstance from "../../../utils/axiosInstance";
import { getbotbyHistsession } from "../../shared/ApiEndpoint";


// Slide transition for Dialog
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const BotFlowHistory = ({open, setOpen ,session_id=null}) => {
  const [messages, setMessages] = useState([
    {
      question: "",
      answer: "",
    },
  ]);

useEffect(() => {
  if (open && session_id) {
    getBotHistory(session_id);
  }
}, [open, session_id]);


  const handleToggle = () => setOpen((prev) => !prev);

const getBotHistory=async(session_id)=>{
 const payload = {
    session_id:session_id
 }
    try {
          const resp = await axiosInstance.post(getbotbyHistsession, payload, {
              headers: {
            'Content-Type': 'application/json'
          },
            withCredentials: true
          });
          if(resp.status===200){
            const resdata=resp.data
            const data= resdata.chat_history.map((item)=>({
                question:item.question,
                answer:item.answer
            }))
            console.log(data,"marinateddata")
            setMessages(data)
          }
    } catch (error) {
        console.log(error)
    }
}
  return (
    <>
      {/* Dialog Box */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleToggle}
        fullWidth
        maxWidth="xs"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
            margin: 0,
            position: "fixed",
            bottom: 20,
            right: 20,
            display: "flex",
            flexDirection: "column",
            height: 500, // fixed height for scroll area
            width:400
          },
        }}
      >
        {/* Header */}
      <Box
  sx={{
    backgroundColor: "#216DB4",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    px: 2,
    py: 1.5,
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  }}
>
  {/* Title */}
  <Typography variant="h6" display="flex" alignItems="center" gap={1}>
    {/* <IoMdChatbubbles /> */}
    Session History
  </Typography>
</Box>


        {/* Messages Scrollable Box */}
        <Box
          sx={{
            p: 2,
            overflowY: "auto",
            flexGrow: 1,
            backgroundColor: "#f9f9f9",
          }}
        >
{messages.map((item, index) => (
  <Box key={index} sx={{ mb: 2 }}>
    {/* Question */}
    <Box
      sx={{
        backgroundColor: "#f1f1f1", // light grey for questions
        px: 2,
        py: 1,
        borderRadius: 2,
        mb: 1,
        maxWidth: "100%",
        wordBreak: "break-word",
      }}
    >
      <Typography variant="body2"><strong>Q:</strong> {item.question}</Typography>
    </Box>

    {/* Answer */}
    <Box
      sx={{
        backgroundColor: "#DCF8C6", // light green for answers
        px: 2,
        py: 1,
        borderRadius: 2,
        maxWidth: "100%",
        wordBreak: "break-word",
      }}
    >
      <Typography variant="body2"><strong>A:</strong> {item.answer}</Typography>
    </Box>
  </Box>
))}   
        </Box>
      </Dialog>
    </>
  );
};

export default BotFlowHistory;
